import React from 'react'

import Navigation from '../components/common/Navigation'
import About from '../components/pages/aboutpage/About'
import Footer from '../components/common/Footer'
import Education from '../components/pages/aboutpage/Education'
import WorkExperience from '../components/pages/aboutpage/WorkExperience'

const AboutPage = () => {
  return (
    <div id='AboutPage'>
      {/* <Navigation /> */}
      <div className="page-contents">
        <About />
        <div className="page-side2side">
          <WorkExperience />
          <Education />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default AboutPage